module.exports = __webpack_public_path__ + "img/mirror03.d285fec4.jpg";